export default __webpack_public_path__ + "static/puppet-00c2f5d1e34a7cefe5d6f28484c1189b.png";